var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "test-root" }, [
    _c("div", [
      _c("div", { staticClass: "layer" }, [
        _c("div", [_vm._v(_vm._s(_vm.userAgent))]),
        _vm.userAgentData
          ? _c("div", [_vm._v(_vm._s(_vm.userAgentData))])
          : _vm._e(),
        _vm.userScreenData
          ? _c("div", { staticClass: "info" }, [
              _c("span", [_vm._v("screen")]),
              _c("span", [_vm._v(_vm._s(_vm.userScreenData))]),
            ])
          : _vm._e(),
        _vm.Hardware.cpu
          ? _c("label", { staticClass: "info" }, [
              _c("span", [_vm._v("cpu")]),
              _c("span", [_vm._v(_vm._s(_vm.Hardware.cpu))]),
            ])
          : _vm._e(),
        _vm.Hardware.battery.instance
          ? _c("label", { staticClass: "info" }, [
              _c("span", [_vm._v("battery")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.Hardware.battery.charging ? "charging," : "") +
                    _vm._s(_vm.Hardware.battery.level * 100) +
                    "%"
                ),
              ]),
            ])
          : _vm._e(),
        _c("label", { staticClass: "info" }, [
          _c(
            "span",
            { style: { color: _vm.Hardware.network.online ? "" : "red" } },
            [_vm._v(_vm._s(_vm.Hardware.network.online ? "online" : "offline"))]
          ),
        ]),
        _vm.Hardware.network.effectiveType
          ? _c("label", { staticClass: "info" }, [
              _c("span", [_vm._v("connType")]),
              _c("span", [_vm._v(_vm._s(_vm.Hardware.network.effectiveType))]),
            ])
          : _vm._e(),
        _vm.Hardware.network.lastChangeDateTime
          ? _c("label", { staticClass: "info" }, [
              _c("span", [_vm._v("lastChage")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.Hardware.network.lastChangeDateTime
                      .toTimeString()
                      .substring(0, 8)
                  )
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _c("div", [
      _c("div", [
        _vm._v(" video:"),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.Device.selected.video,
                expression: "Device.selected.video",
              },
            ],
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.Device.selected,
                  "video",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          _vm._l(_vm.Device.list.video, function (Device) {
            return _c(
              "option",
              { key: Device.deviceId, domProps: { value: Device.deviceId } },
              [_vm._v(_vm._s(Device.label))]
            )
          }),
          0
        ),
      ]),
      _c("div", [
        _c("button", { on: { click: _vm.playVideo } }, [_vm._v("play")]),
        _c("button", { on: { click: _vm.stopVideo } }, [_vm._v("stop")]),
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                _vm.ui.oriSize = !_vm.ui.oriSize
              },
            },
          },
          [_vm._v("ori size")]
        ),
        this.trackInfo.settings
          ? _c("div", [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.trackInfo.settings,
                    expression: "trackInfo.settings",
                  },
                ],
                staticStyle: { width: "660px" },
                domProps: { value: _vm.trackInfo.settings },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.trackInfo, "settings", $event.target.value)
                  },
                },
              }),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.trackInfo.constraints,
                    expression: "trackInfo.constraints",
                  },
                ],
                staticStyle: { width: "660px", height: "30px" },
                domProps: { value: _vm.trackInfo.constraints },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.trackInfo, "constraints", $event.target.value)
                  },
                },
              }),
              _c("button", { on: { click: _vm.applyVideoConstraints } }, [
                _vm._v("apply"),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _c("div", { ref: "videoLayer", staticClass: "layer preview-video-layer" }, [
      _c("video", {
        ref: "prevVideo",
        attrs: { autoplay: "", playsinline: "", crossorigin: "anonymous" },
        on: { loadedmetadata: _vm.setTrackInfo, play: _vm.onVideoPlay },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }